import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { topicVocabularyData, getDataForDifficulty } from '../courses/data/vocabulary/topicVocabulary';

export default function TopicRelatedVocabularyTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : topicVocabularyData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
